import { render, staticRenderFns } from "./Links.vue?vue&type=template&id=1f80af1e&scoped=true"
import script from "./Links.vue?vue&type=script&lang=js"
export * from "./Links.vue?vue&type=script&lang=js"
import style0 from "./Links.vue?vue&type=style&index=0&id=1f80af1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f80af1e",
  null
  
)

export default component.exports